/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ResponseCollectionLoggerMessage', 'model/ResponseCollectionString'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ResponseCollectionLoggerMessage'), require('../model/ResponseCollectionString'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.LoggersApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ResponseCollectionLoggerMessage, root.GisServerApis.ResponseCollectionString);
  }
}(this, function(ApiClient, ResponseCollectionLoggerMessage, ResponseCollectionString) {
  'use strict';

  /**
   * Loggers service.
   * @module api/LoggersApi
   * @version 1.0.0
   */

  /**
   * Constructs a new LoggersApi. 
   * @alias module:api/LoggersApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getLoggerMessageByDateRangeV1 operation.
     * @callback module:api/LoggersApi~getLoggerMessageByDateRangeV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseCollectionLoggerMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the logs for the a specified date range.
     * @param {Object} opts Optional parameters
     * @param {Date} opts.from The start date to query
     * @param {Date} opts.to The end date to query
     * @param {module:api/LoggersApi~getLoggerMessageByDateRangeV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseCollectionLoggerMessage}
     */
    this.getLoggerMessageByDateRangeV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'from': opts['from'],
        'to': opts['to'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseCollectionLoggerMessage;

      return this.apiClient.callApi(
        '/api/v1/loggers/logs', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getLoggerMessageByManagerNameAndDateRangeV1 operation.
     * @callback module:api/LoggersApi~getLoggerMessageByManagerNameAndDateRangeV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseCollectionLoggerMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the logs for a specified logger manager with a specified date range.
     * @param {String} managerName The manager name to query
     * @param {Object} opts Optional parameters
     * @param {Date} opts.from The start date to query
     * @param {Date} opts.to The end date to query
     * @param {module:api/LoggersApi~getLoggerMessageByManagerNameAndDateRangeV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseCollectionLoggerMessage}
     */
    this.getLoggerMessageByManagerNameAndDateRangeV1 = function(managerName, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'managerName' is set
      if (managerName === undefined || managerName === null) {
        throw new Error("Missing the required parameter 'managerName' when calling getLoggerMessageByManagerNameAndDateRangeV1");
      }


      var pathParams = {
        'managerName': managerName
      };
      var queryParams = {
        'from': opts['from'],
        'to': opts['to'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseCollectionLoggerMessage;

      return this.apiClient.callApi(
        '/api/v1/loggers/{managerName}/logs', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getLoggerNamesV1 operation.
     * @callback module:api/LoggersApi~getLoggerNamesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseCollectionString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all the names of logger managers
     * @param {module:api/LoggersApi~getLoggerNamesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseCollectionString}
     */
    this.getLoggerNamesV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseCollectionString;

      return this.apiClient.callApi(
        '/api/v1/loggers/managerNames', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

